module.exports = __webpack_public_path__ + "h5/img/5.dd03ac3c.png";